import {Card} from "react-bootstrap";
import PropTypes from 'prop-types';
import {getColor} from 'helpers/utils';
import {LineChart} from 'echarts/charts';
import * as echarts from 'echarts/core';
import {useSafeQuery} from "@dladio/hooks";
import {CanvasRenderer} from 'echarts/renderers';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import {EXEC_QUERY_METHOD} from "@dladio/service/dist/const/erp-method.consts";
import {useExecMethodApiQuery} from "@dladio/service";
import React, {useEffect, useRef} from 'react';
import {GridComponent, LegendComponent, TitleComponent, TooltipComponent} from 'echarts/components';

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LineChart,
    CanvasRenderer,
    LegendComponent
]);

const ArPieChart = ({query}) => {
    const chartRef = useRef(null)

    const {data} = useSafeQuery(useExecMethodApiQuery, {
        method: EXEC_QUERY_METHOD, body: {
            name: query,
        },
    });

    let resolvingValue = _.get(data, ["message"]) ?? []

    const getOption = () => ({
        tooltip: {
            trigger: 'item',
            padding: [7, 10],
            backgroundColor: getColor('gray-100'),
            borderColor: getColor('gray-300'),
            textStyle: {color: getColor('dark')},
            borderWidth: 1,
            transitionDuration: 0,
            axisPointer: {
                type: 'none'
            }
        },

        series: [
            {
                type: 'pie',
                radius: window.innerWidth < 530 ? '45%' : '60%',
                center: ['50%', '50%'],
                data: resolvingValue,
                label: {
                    position: 'outer',
                    alignTo: 'labelLine',
                    bleedMargin: 5,
                    color: getColor('gray-700')
                },
                left: '5%',
                right: '5%',
                top: 0,
                bottom: 0
            }
        ]
    })

    const updateDimensions = () => {
        if (window.innerWidth < 530) {
            chartRef.current.getEchartsInstance().setOption({
                series: [{radius: '45%'}]
            });
        } else
            chartRef.current.getEchartsInstance().setOption({
                series: [{radius: '60%'}]
            });
    }

    useEffect(() => {
        window.addEventListener('resize', updateDimensions);
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    return (
        <div className="position-relative h-100">
            <Card className={'h-100 d-flex justify-content-center align-content-center'}>
                <ReactEChartsCore
                    echarts={echarts}
                    option={getOption()}
                    ref={chartRef}
                    style={{height: '18.4rem'}}
                />
            </Card>
        </div>
    );
};

ArPieChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.array)
};

export default ArPieChart;
